/*
  Description: This file contains all Protected Routes
*/
import React, { useContext } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
/// Css
//import "swiper/css";
import "./index.css";
import "./chart.css";
import "./step.css";
/// Layout
import Nav from "./layouts/nav";
import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "./components/Dashboard/Home";
//Customers
import CustomersList from "./components/Customers/CustomersList";
/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";
import EditProfile from "./components/AppsMenu/AppProfile/EditProfile";
import Error400 from "./pages/Error400";
import Setting from "./layouts/Setting";
import { ThemeContext } from "../context/ThemeContext";
import Userlist from "./components/Employee/EmployeeList";
import AddEmployee from "./components/Employee/AddEmployee";
import ViewCustomerDetails from "./components/Customers/ViewCustomerDetails";
import ViewEmployeeDetails from "./components/Employee/EmployeeDetails/ViewEmployeeDetails";
import EditEmployee from "./components/Employee/EditEmployee";
import NotificationList from "./components/Notification/NotificationList";
import CreateNotification from "./components/Notification/CreateNotification";
import Error403 from "./pages/Error403";
import EditCustomer from "./components/Customers/EditCustomer";
import Roles from "./components/Roles/Roles";
//Transactions
import TransactionDetails from "./components/TransactionDetails/TransactionDetails";
import Transaction from "./components/Transaction/Transaction";
//Reports
import DailyPointReport from "./components/Reports/DailyPoint/DailyPointReport";
import RewardRedemptionReport from "./components/Reports/RewardRedemption/RewardRedemptionReport";
import TransactionsReport from "./components/Reports/TransactionsReport/TransactionsReport";
import CustomerReport from "./components/Reports/CustomerReport/CustomerReport";
import StorePurchaseReport from "./components/Reports/StorePurchaseReport/StorePurchaseReport";
import SubscribedCustomer from "./components/Reports/SubscribedCustomer/SubscribedCustomer";
import SubscriptionReport from "./components/Reports/SubscriptionReport/SubscriptionReport";
import InstoreRequest from "./components/InstoreRequest/InstoreRequest";

const ProtectedRoutes = () => {
  const allroutes = [
    // Dashboard
    // { url: "/", component: <Home />, moduleName: "dashboard" },
    { url: "dashboard", component: <Home />, moduleName: "dashboard" },

    //User
    { url: "users", component: <Userlist />, moduleName: "employee_onboard" },
    { url: "add-user", component: <AddEmployee />, moduleName: "employee_onboard" },
    { url: "user-details/:id", component: <ViewEmployeeDetails />, moduleName: "employee_onboard" },
    { url: "edit-user/:id", component: <EditEmployee />, moduleName: "employee_onboard" },

    // Transactions/ Gift/Redeem/Rewards
    { url: "transactions", component: <Transaction />, moduleName: "transactions" },
    { url: "transactions-details/:id", component: <TransactionDetails />, moduleName: "transactions" },

    //Customers
    { url: "customers", component: <CustomersList />, moduleName: "customers" },
    { url: "view-customer-details/:id", component: <ViewCustomerDetails />, moduleName: "customers" },
    { url: "edit-customer/:id", component: <EditCustomer />, moduleName: "customers" },

    //Notifications
    { url: "notification", component: <NotificationList />, moduleName: "notifications" },
    { url: "create-notification", component: <CreateNotification />, moduleName: "notifications" },

    // Apps
    { url: "app-profile", component: <AppProfile />, moduleName: "settings" },
    // { url: "post-details", component: <PostDetails />, moduleName: "settings" },
    // { url: "edit-profile", component: <EditProfile />, moduleName: "settings" },

    //Roles
    { url: "roles", component: <Roles />, moduleName: "roles" },

    //Reports
    { url: "dailyPoint", component: <DailyPointReport />, moduleName: "reports" },
    { url: "subscribedCustomerReport", component: <SubscribedCustomer />, moduleName: "reports" },
    { url: "rewardRedemption", component: <RewardRedemptionReport />, moduleName: "reports" },
    { url: "dailyCustomerReport", component: <CustomerReport />, moduleName: "reports" },
    { url: "storePurchase", component: <StorePurchaseReport />, moduleName: "reports" },
    { url: "subscription", component: <SubscriptionReport />, moduleName: "reports" },
    { url: "transactionReport", component: <TransactionsReport />, moduleName: "reports" },
    { url: "redeem_requests", component: <InstoreRequest />, moduleName: "redeem_requests" },
    // { url: "transactionReport", component: <GiftRewardRedeemReport />, moduleName: "reports" },
  ];
  const RoleBasedRoute = ({ allowedRoles, children, moduleName }) => {
    const userRole = localStorage.getItem("userRole");
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const role_permissions = userDetails.role_permissions;
    console.log("Role permissions", role_permissions)
    // const role_permissions = { customers: false, employee_onboard: true, notifications: true, reports: true, roles: true, sales_data: true, settings: true, transactions: true };
    // if (!allowedRoles.includes(userRole)) {
    //   return <Navigate to='/forbidden' />;
    // }
    if (moduleName == "dashboard") {
      return children;
    }
   
    if (!role_permissions[moduleName]) {
      return <Navigate to='/forbidden' />;
    }
    return children;
  };

  return (
    <>
      <Routes>
        <Route element={<MainLayout />}>
          {allroutes.map((route, i) => (
            <Route
              key={i}
              path={route.url}
              element={
                <RoleBasedRoute allowedRoles={route.allowedRoles} moduleName={route.moduleName}>
                  {route.component}
                </RoleBasedRoute>
              }
            />
          ))}
        </Route>
        <Route path='/forbidden' element={<Error403 />} />
        <Route path='*' element={<Error400 />} />
      </Routes>
      <Setting />
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <div id='main-wrapper' className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${menuToggle ? "menu-toggle" : ""}`}>
      <Nav />
      <div className='content-body' style={{ minHeight: window.screen.height - 45 }}>
        <div className='container-fluid'>
          <Outlet />
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default ProtectedRoutes;
